<template>
  <div>
    <div class="container">
      <div class="card rounded shadow my-3">
        <div class="card-body text-center">
          <img src="/media/failed.svg" class="w-25 mx-auto" alt="checked">

          <h3 class="text-danger mt-3 mb-2 font-weight-bold">
            پرداخت ناموفق
          </h3>

          <label class="m-0 dir-rtl">
            خطا در انجام تراکنش
          </label>

          <hr/>

          <div class="container">
            <div class="row dir-rtl">
              <div class="col-4 p-0">
                <label class="w-100 text-black-50 text-right">
                  مبلغ :
                </label>
              </div>

              <div class="col-8 p-0 text-left dir-ltr">
                {{ info.increaseAmount | rial }} ریال
              </div>

              <div class="col-4 p-0">
                <label class="w-100 text-black-50 text-right">
                  تاریخ و ساعت :
                </label>
              </div>

              <div class="col-8 p-0 text-left dir-ltr" dir="ltr">
                {{ info.createdAt | longDate }}
              </div>

              <div class="col-md-6 p-0 pr-1 mx-auto">
                <a class="btn btn-danger w-100" style="font-size: 16px" @click="openOrigin">
                  <i class="fa fa-remove"></i>
                  <b>بازگشت به صفحه مرجع</b>
                </a>
              </div>
            </div>
          </div>
        </div>
        <label class="w-100 text-center text-black-50 dir-rtl" style="font-size: small">
          تمامی حقوق این نرم افزار برای ترمینال تبلیغات محفوظ است .
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  methods: {
    openOrigin() {
      window.location.replace(this.info.callBack)
    },
  }

}
</script>